import React from "react";

export const Spinner: React.FC<{ className?: string }> = ({ className = "" }) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className={`animate-spin ${className}`} aria-label="Loading">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2.4" opacity="0.25" />
        <path d="M21 12a9 9 0 00-9-9" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
    </svg>
);
